// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"ExtensionFilter_inputWrapper__mnq8V","button":"ExtensionFilter_button__u_wsF"};